const RYOK_RESIZE =
  /^(https?:\/\/ryok\.tvheryerde\.com\/ake\/resize\/)([1-9]\d*)\/([1-9]\d*)(\/[^?#]+(?:[?#].*)?)$/i;

// Banner renditions are explicitly Full HD; poster/card requests are unaffected.
export const getBannerRendition = (src) => {
  const match = typeof src === "string" && src.match(RYOK_RESIZE);
  return match ? `${match[1]}1920/1080${match[4]}` : src;
};

export const getBannerSource = (posters, fallback) => {
  const candidates = ["Web Banner", "Web Landscape"]
    .map((type) => (Array.isArray(posters) ? posters : [])
      .find((poster) => poster?.type === type)?.url)
    .filter(Boolean);
  // Prefer genuine landscape artwork when the catalog labels a portrait as a banner.
  const landscape = candidates.find((src) => {
    const match = src.match(RYOK_RESIZE);
    return !match || Number(match[2]) >= Number(match[3]);
  });
  return landscape || candidates[0] || fallback;
};
